import {React, useState} from 'react';
import {Link} from 'react-router-dom';
import {Grid, Box, Button, Paper, createTheme, ThemeProvider, Typography} from '@mui/material';
import {Addchart,SocialDistance, RequestQuote, Summarize, MoneyOff, CurrencyRuble, Timelapse, VolunteerActivism, PeopleAlt} from '@mui/icons-material';


function Reports(){

  const [values, setValues] = useState();
  const [openPopup, setOpenPopup] = useState(false);

  const theme = createTheme({
    palette: {
      primary: { main: '#0b418e' },
      danger: {
        main: '#ffeb3b',
      },
      orange: {
        main: '#ff5722',
      },
      blueGrey: {
        main: '#607d8b',
      },
      lightGreen: {
        main: '#689f38',
      },
      pink: {
        main: '#ec407a',
      },
    },
  });

  return(
    <ThemeProvider theme={theme}>
    <Box className="master-button-container">
      <Paper className="paper-container" elevation={5} sx={{width: "1000px", padding: "30px"}}>
      <Typography variant="h4" sx={{textAlign: "center", marginBottom: "20px"}}>Reports</Typography>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="combine-salary-report" className="link">
                <Button id="btn1" sx={{color: "white"}} className="master-btn" variant="contained" color="pink" startIcon={<RequestQuote sx={{width: "30px", height: "30px"}}/>} >
                  Salary Report
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="income-tax-report" className="link">
                <Button id="btn-income-tax" sx={{color: "white"}} className="master-btn" variant="contained" color="primary" startIcon={<RequestQuote sx={{width: "30px", height: "30px"}}/>} >
                  Income Tax Report
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="provident-fund-report" className="link">
                <Button id="btn2" sx={{color: "white"}} className="master-btn" variant="contained" color="lightGreen" startIcon={<MoneyOff sx={{width: "30px", height: "30px"}}/>} >
                  Provident Fund Report
                </Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="professional-tax-report" className="link">
                <Button id="btn3" sx={{color: "white"}} className="master-btn" variant="contained" color="blueGrey" startIcon={<CurrencyRuble sx={{width: "30px", height: "30px"}}/>} >
                    Profession Tax Report
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="bank-statement-report" className="link">
                <Button id="btn4" sx={{color: "white"}} className="master-btn" variant="contained" color="primary" startIcon={<Summarize sx={{width: "30px", height: "30px"}}/>} >
                  Bank Statement Report
                </Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="esi-statement-report" className="link">
                <Button id="btn5" sx={{color: "white"}} className="master-btn" variant="contained" color="success" startIcon={<Addchart sx={{width: "30px", height: "30px"}}/>} >
                  ESI Statement Report
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="separation-rate-report" className="link">
                <Button id="btn6" sx={{color: "white"}} className="master-btn" variant="contained" color="orange" startIcon={<SocialDistance sx={{width: "30px", height: "30px"}}/>} >
                  Separation Rate Report
                </Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="combine-salary-report-duration" className="link">
                <Button id="btn7" sx={{color: "white"}} className="master-btn" variant="contained" color="error" startIcon={<Timelapse sx={{width: "30px", height: "30px"}}/>} >
                  Salary Report Duration
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="gratuity-report" className="link">
                <Button id="btn8" sx={{color: "white"}} className="master-btn" variant="contained" color="lightGreen" startIcon={<VolunteerActivism sx={{width: "30px", height: "30px"}}/>} >
                  Gratuity Report
                </Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="top-employees-report" className="link">
                <Button id="btn9" sx={{color: "white"}} className="master-btn" variant="contained" color="primary" startIcon={<PeopleAlt sx={{width: "30px", height: "30px"}}/>} >
                  Top Employees Report
                </Button>
              </Link>
            </Grid>
          </Grid>

      </Paper>
    </Box>
    </ThemeProvider>
  )
}

export default Reports;
